export default {
  en: {
    fileBrowser: {
      folders: {
        title: 'Matters',
        search: 'Search',
        elements: 'no element | {count} element | {count} element',
        not_found: 'No repertory found'
      },
      files: {
        title: 'Files',
        select_folder: 'Choose a matter',
        upload: 'Upload files',
        upload_in_progress: 'Upload in progress',
        upload_error_size: 'Too large file ',
        upload_error: 'An error has occurred',
        upload_button_title: 'This folder is read-only'
      }
    },
    menu: {
      home: 'Dashboard',
      matters: 'Matters',
      documents: 'My documents',
      invoices: 'Invoices'
    },
    general: {
      welcome: 'Welcome',
      cancel: 'Cancel',
      email: 'Email',
      password: 'Password',
      selected: 'Selected',
      search: 'Search',
      no_result: 'No result found.',
      parameters: 'Parameters',
      logout: 'Logout',
      validate: 'Validate',
      loading: 'Loading',
      open: 'Open',
      archived: 'Archived',
      print: 'Print',
      export: 'Export'
    },
    login: {
      connection: 'Connection',
      email_mandatory: 'Email is mandatory.',
      password_mandatory: 'Password is mandatory.',
      invalid_credentials: 'Invalid credentials or disabled access.',
      forgot_password: 'Forgot password ?'
    },
    law_firm_selection: {
      access: 'Access the {law_firm_name} law firm portal'
    },
    forgot_password: {
      account_not_found: 'Account not found.',
      email_mandatory: 'Email is mandatory.',
      reinit: 'Reset password',
      confirmation: {
        text: 'An e-mail has been sent. It contains a link that you will need to click on to reset your password. <br/><br/>If you do not receive an email, check your spam folder or try again.',
        back: 'Return to the login page'
      }
    },
    reset_password: {
      title: {
        first_attempt: 'Choose a secure password',
        next_attempt: 'Reset your password'
      },
      failed: 'An error occurred when resetting the password.',
      password_not_same: 'The passwords do not match.',
      specify_password: 'Please enter a password.',
      please_confirm_password: 'Please confirm the password.',
      confirm_password: 'Confirm password',
      confirmation: {
        text: 'Your password has been reset.',
        back_1: 'You can now',
        back_2: 'connect.'
      }
    },
    header: {
      notification: {
        count: 'You have 0 notification | You have {count} notification | You have {count} notifications'
      }
    },
    not_found: {
      text: 'Oops! Page not found.',
      back_1: 'Back to',
      back_2: 'home page'
    },
    matter: {
      datatable: {
        name: 'Matter',
        practiceArea: 'Practice area',
        currency: 'Currency',
        manager: 'Manager',
        creationDate: 'Creation date'
      }
    },
    data_table: {
      sProcessing: 'Traitement en cours...',
      sSearch: 'Rechercher :',
      sLengthMenu: 'Afficher _MENU_ éléments',
      sInfo: 'Affichage de l\'élément _START_ à _END_ sur _TOTAL_ éléments',
      sInfoEmpty: 'Affichage de l\'élément 0 à 0 sur 0 élément',
      sInfoFiltered: '',
      sInfoPostFix: '',
      'sZeroRecords"': 'Aucun résultat',
      sLoadingRecords: 'Chargement en cours...',
      sZeroRecords: 'Aucun élément à afficher',
      sEmptyTable: 'Aucune donnée disponible',
      oPaginate: {
        sFirst: 'Premier',
        sPrevious: 'Précédent',
        sNext: 'Suivant',
        sLast: 'Dernier'
      },
      oAria: {
        sSortAscending: ': activer pour trier la colonne par ordre croissant',
        sSortDescending: ': activer pour trier la colonne par ordre décroissant'
      },
      select: {
        rows: {
          0: 'Aucune ligne séléctionnée',
          1: '1 ligne séléctionnée',
          _: '%d lignes séléctionnées'
        }
      },
      button: {
        columns_to_display: 'Choix des colonnes à afficher'
      }
    },
    sharepoint: {
      open_folder: 'Open the folder'
    }
  },
  fr: {
    fileBrowser: {
      folders: {
        title: 'Répertoires',
        search: 'Rechercher',
        elements: 'aucun élément | {count} élément | {count} éléments',
        not_found: 'Aucun répertoire correspondant'
      },
      files: {
        title: 'Fichiers',
        select_folder: 'Selectionnez un répertoire',
        upload: 'Déposer des fichiers',
        upload_in_progress: 'Dépôt de fichiers en cours',
        upload_error_size: 'Fichier trop volumineux',
        upload_error: 'Une erreur est survenue',
        upload_button_title: 'Ce dossier est en lecture seule'
      }
    },
    menu: {
      home: 'Dashboard',
      matters: 'Dossiers',
      documents: 'Mes documents',
      invoices: 'Factures'
    },
    general: {
      welcome: 'Bienvenue',
      cancel: 'Annuler',
      email: 'Email',
      password: 'Mot de passe',
      selected: 'Sélectionné',
      search: 'Rechercher',
      no_result: 'Aucun élément trouvé.',
      parameters: 'Paramètres',
      logout: 'Déconnexion',
      validate: 'Valider',
      loading: 'Chargement',
      open: 'Ouvert',
      archived: 'Archivé',
      print: 'Imprimer',
      export: 'Exporter'
    },
    login: {
      connection: 'Connexion',
      email_mandatory: 'L\'email est obligatoire.',
      password_mandatory: 'Le mot de passe est obligatoire.',
      invalid_credentials: 'Identifiants invalides ou accès désactivé.',
      forgot_password: 'Mot de passe oublié ?'
    },
    law_firm_selection: {
      access: 'Accéder au Portail du cabinet {law_firm_name}'
    },
    forgot_password: {
      account_not_found: 'Compte introuvable.',
      email_mandatory: 'L\'email est obligatoire.',
      reinit: 'Réinitialiser le mot de passe',
      confirmation: {
        text: 'Un e-mail a été envoyé. Il contient un lien sur lequel il vous faudra cliquer pour réinitialiser votre mot de passe.<br/><br/>Si vous ne recevez pas un email, vérifiez votre dossier spam ou essayez à nouveau.',
        back: 'Retourner sur la page de connexion'
      }
    },
    reset_password: {
      title: {
        first_attempt: 'Choisissez un mot de passe sécurisé',
        next_attempt: 'Réinitialisation de votre mot de passe'
      },
      failed: 'Une erreur est survenue lors de l\'enregistrement du mot de passe.',
      password_not_same: 'Les mots de passe ne correspondent pas.',
      specify_password: 'Veuillez indiquer un mot de passe.',
      please_confirm_password: 'Veuillez confirmer le mot de passe.',
      confirm_password: 'Confirmer le mot de passe',
      confirmation: {
        text: 'Votre mot de passe a bien été enregistré.',
        back_1: 'Vous pouvez maintenant vous',
        back_2: 'connecter.'
      }
    },
    header: {
      notification: {
        count: 'Vous avez 0 notification | Vous avez {count} notification | Vous avez {count} notifications'
      }
    },
    not_found: {
      text: 'Oops! Page non trouvée.',
      back_1: 'Retourner sur',
      back_2: 'la page d\'accueil'
    },
    matter: {
      datatable: {
        name: 'Nom',
        practiceArea: 'Nature',
        currency: 'Devise',
        manager: 'Gestionnaire',
        creationDate: 'Date de création'
      }
    },
    data_table: {
      sProcessing: 'Traitement en cours...',
      sSearch: 'Rechercher :',
      sLengthMenu: 'Afficher _MENU_ éléments',
      sInfo: 'Affichage de l\'élément _START_ à _END_ sur _TOTAL_ éléments',
      sInfoEmpty: 'Affichage de l\'élément 0 à 0 sur 0 élément',
      sInfoFiltered: '',
      sInfoPostFix: '',
      'sZeroRecords"': 'Aucun résultat',
      sLoadingRecords: 'Chargement en cours...',
      sZeroRecords: 'Aucun élément à afficher',
      sEmptyTable: 'Aucune donnée disponible',
      oPaginate: {
        sFirst: 'Premier',
        sPrevious: 'Précédent',
        sNext: 'Suivant',
        sLast: 'Dernier'
      },
      oAria: {
        sSortAscending: ': activer pour trier la colonne par ordre croissant',
        sSortDescending: ': activer pour trier la colonne par ordre décroissant'
      },
      select: {
        rows: {
          0: 'Aucune ligne séléctionnée',
          1: '1 ligne séléctionnée',
          _: '%d lignes séléctionnées'
        }
      },
      button: {
        columns_to_display: 'Choix des colonnes à afficher'
      }
    },
    sharepoint: {
      open_folder: 'Accéder au contenu du répertoire'
    }
  }
}
